"use client"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"
import GenericRefinementWorkspace from "../refinement/GenericRefinementWorkspace"

export default function PositionRefinementPage() {
  const { positionId } = useParams()
  const { getAccessTokenSilently } = useAuth0()
  const [position, setPosition] = useState(null)
  useEffect(() => {
    let active = true
    const load = async () => {
      const token = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE } })
      const response = await fetch(`${getApiBaseUrl()}/api/positions/${positionId}`, { headers: { Authorization: `Bearer ${token}` } })
      if (active && response.ok) setPosition(await response.json())
    }
    load().catch(() => {})
    return () => { active = false }
  }, [positionId, getAccessTokenSilently])
  return <GenericRefinementWorkspace
    type="position" itemId={positionId} itemLabel="Role" item={position} title={position?.title || "this role"}
    currentFields={[
      { label: "Purpose", value: position?.positionDescription || position?.description },
      { label: "Responsibilities", value: position?.positionDuties || position?.duties },
      { label: "Time and compensation", value: position?.weeklyCompensation ? `${position.weeklyCompensation} weekly` : "" },
      { label: "Location", value: [position?.city, position?.region, position?.country].filter(Boolean).join(", ") },
    ]}
    fieldOptions={[
      { value: "PositionDescription", label: "Purpose or description" },
      { value: "PositionDuties", label: "Responsibilities" },
      { value: "WeeklyCompensation", label: "Compensation" },
      { value: "Schedule", label: "Schedule and time commitment" },
      { value: "Qualifications", label: "Qualifications" },
      { value: "Accountability", label: "Accountability and reporting" },
    ]}
  />
}
